const INVALID_STRING_TOKENS = new Set([
    '[object object]',
    '[object promise]',
    'undefined',
    'null'
]);

function resolveObjectCandidate(value) {
    if (!value || typeof value !== 'object') return undefined;
    if (value.label) return value.label;
    if (value.name) return value.name;
    if (value.title) return value.title;
    if (value.code) return value.code;
    if (value.slug) return value.slug;
    if (value.id) return value.id;
    return undefined;
}

export function safeText(value, options = {}) {
    const {
        fallback = 'NÃO DEFINIDO',
        emptyFallback = fallback,
        invalidFallback = fallback,
        allowZero = true,
        joiner = ', '
    } = options;

    if (value === null || value === undefined) {
        return fallback;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) return emptyFallback;
        const lowered = trimmed.toLowerCase();
        if (INVALID_STRING_TOKENS.has(lowered)) return invalidFallback;
        if (trimmed.startsWith('[object ')) return invalidFallback;
        return trimmed;
    }

    if (typeof value === 'number') {
        if (!allowZero && value === 0) return fallback;
        return Number.isFinite(value) ? String(value) : invalidFallback;
    }

    if (typeof value === 'boolean') {
        return value ? 'SIM' : 'NÃO';
    }

    if (value instanceof Date) {
        return value.toLocaleString('pt-BR');
    }

    if (Array.isArray(value)) {
        const rendered = value
            .map((entry) => safeText(entry, { fallback: '', emptyFallback: '', invalidFallback: '', allowZero }))
            .filter((entry) => !!entry);
        return rendered.length ? rendered.join(joiner) : fallback;
    }

    const candidate = resolveObjectCandidate(value);
    if (candidate !== undefined) {
        return safeText(candidate, { fallback, emptyFallback, invalidFallback, allowZero, joiner });
    }

    if (typeof value === 'bigint') {
        return value.toString();
    }

    return fallback;
}

export function ensureText(value, fallback) {
    return safeText(value, { fallback });
}